export default {
    listagem: {
        titulo_pagina: 'Lista de Integrações',
        novo: 'Criar nova Integração',
        campos_tabela: 'Campos da tabela',
        table: {
            empty: 'Nenhuma Integração encontrada',
            nome: 'Nome',
            protocolo: 'Protocolo',
            mnemonico: 'Mnemônico',
            fabricante: 'Fabricante',
            tipo_integracao: 'Tipo de Integração',
            complemento: 'Complemento',
            tipo_complemento: 'Tipo do complemento',
            forcar_complemento: 'Forçar complemento',
            tamanho_recipiente: 'Tamanho do identificador do recipiente',
            file_format: 'Formato de arquivo',
            host_homologacao: 'Host de homologação',
            host_producao: 'Host de produção',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar nova Integração',
            editar: 'Editar Integração'
        },
        fieldsets: {
            informacoes: 'Informações',
            comunicacao: 'Comunicação',
            hosts: 'Hosts',
            camada: 'Camada Anti Corrupção'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome da Integração'
            },
            mnemonico: {
                label: 'Mnemômico',
                description: 'Sigla da Integração'
            },
            tipo_integracao: {
                label: 'Tipo da Integração',
                description: 'Tipo de Integração utilizada'
            },
            fabricante: {
                label: 'Fabricante',
                description: 'Fabricante da Integração'
            },
            protocolo: {
                label: 'Protocolo',
                description: 'Protocolo de comunicação da Integração'
            },
            formato_arquivo: {
                label: 'Formato de Arquivo',
                description: 'Formato de arquivo utilizado na da Integração'
            },
            pubsub_topic_result_out: {
                label: 'Tópico do PubSub de Resultado',
                description: 'Tópico do PubSub de Resultado de Saída'
            },
            pubsub_topic_order_out: {
                label: 'Tópico do PubSub de Ordem',
                description: 'Tópico do PubSub de Ordem de Saída'
            },
            pubsub_topic_label_out: {
                label: 'Tópico do PubSub do Label',
                description: 'Tópico do PubSub do Label de Saída'
            },
            host_homologacao: {
                label: 'Host de Homologação',
                description: 'Host utilizado para homologar a Integração'
            },
            host_producao: {
                label: 'Host de Produção',
                description: 'Host onde apontará a Integração'
            },
            empresa: {
                label: 'Empresa',
                description: 'Empresa que poderá executar a Integração'
            },
            equipamento: {
                label: 'Equipamento',
                description: 'Equipamento autorizado à Integração'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo da Integração'
            },
            sport: {
                label: 'Integração de Esporte',
                description: 'Integração esportiva que trabalha com atletas'
            },
            bloquear_dexpara: {
                label: 'Bloquear Envio',
                description: 'Bloqueia o envio em caso de erro de deXpara'
            },
            bypass_material_complement: {
                label: 'Bypass Material Complementar',
                description: 'Permite o processamento da integração sem a obrigatoriedade do de/para do material complementar'
            },
            botao_salvar : 'Salvar Integração'
        },
        create: {
            success: 'Integração criada com Sucesso!',
            error: 'Error ao criar Integração!'
        },
        update: {
            success: 'Integração editada com Sucesso!',
            error: 'Error ao editar Integração!'
        },
        errors: {
            possible_specimens_linked: 'Não é possível alterar o tipo da integração pois existem Materiais Possíveis cadastrados vinculados a essa integração'
        }
    }
}
